export default __webpack_public_path__ + "static/media/NibiruKnight.2b13f506.png";